import cookies from 'js-cookie'

let userInfoSync = cookies.get('userInfo')
let tokenSync = cookies.get('token')

if (typeof userInfoSync !== 'undefined' && userInfoSync !== 'undefined') {
  userInfoSync = JSON.parse(userInfoSync)
}

const user = {
  state: {
    userInfo: userInfoSync || {},
    token: tokenSync || '',
    globalVip: false
  },
  mutations: {
    SET_GLOBALVIP: (state, vipinfo) => {
      state.globalVip = vipinfo
      cookies.set('globalVip', vipinfo)
    },
    SET_USERINFO: (state, newUserInfo) => {
      state.userInfo = newUserInfo
      cookies.set('userInfo', newUserInfo)
    },
    RESULTS_USERINFO: state => {
      state.userInfo = {}
      cookies.remove('userInfo')
    },
    SET_TOKEN: (state, newToken) => {
      // console.log(newUserInfo)
      state.token = newToken
      cookies.set('token', newToken)
    },
    RESULTS_TOKEN: state => {
      state.token = ''
      cookies.remove('token')
    }
  },
  actions: {
    setGlobalVip: ({ commit }, vipinfo) => {
      return commit('SET_GLOBALVIP', vipinfo)
    },
    setUserInfo: ({ commit }, newUserInfo) => {
      return commit('SET_USERINFO', newUserInfo)
    },
    resultsUserInfo: ({ commit }) => {
      return commit('RESULTS_USERINFO')
    },
    setToken: ({ commit }, newToken) => {
      return commit('SET_TOKEN', newToken)
    },
    resultsToken: ({ commit }) => {
      return commit('RESULTS_TOKEN')
    }
  }
}

export default user
